export enum TranslationLanguage {
    ENGLISH = 'en',
    FRENCH = 'fr',
}
